// to refactor in multiple sub-classes
export default class Form {
  constructor(data, form) {
    this.data = data;
    this.form = form;
  }

  init() {
    if (!this.form) 
      return;
    
    this.init_selects_show();
    this.prefill_select();
    this.init_prefill_position();
    this.init_prefill_email_receiver();
    this.init_inputs_file();
    this.on_form_submit();
  }

  init_prefill_email_receiver() {
    const input = this.form.querySelector(".js-op-prefill-email-receiver");
    if (!(input && this.data?.email_receiver)) 
      return;

    input.value = this.data.email_receiver;
  }

  init_prefill_position() {
    const input = this.form.querySelector(".js-op-prefill-position");
    if (!(input && this.data?.position_areas.length > 0))
      return;

    const default_area = this.data.position_areas[0];    
    input.value = default_area.name;
  }

  init_selects_show() {
    const handlers = this.form.querySelectorAll(".js-select-show-next");
    const targets = this.form.querySelectorAll(".js-handler-target");    
    handlers?.forEach((select, i) => {      
      const target = targets[i];
      if (!target)
        return;
      
      select.addEventListener("change", (e) => {
        if (e.target.value === target.dataset.showOn) {
          target.classList.remove("is-hidden");
        
        } else {
          !target.classList.contains("is-hidden")
            && target.classList.add("is-hidden");
        }
      });
    });
  }

  on_form_submit() {
    document.addEventListener("wpcf7submit", (e) => {
      const sent = e.detail.status;
      if (sent === "mail_sent") {
        this.form.querySelectorAll("input[type='file']")?.forEach((input) => {
          input.value = "";
          const input_wrap = input.closest(".input-wrap-file");
          const input_visible = input_wrap?.querySelector(".js-single-input-visible");
          const message_hint = input_wrap?.querySelector(".js-input-file-hint");
          const message_ok = input_wrap?.querySelector(".js-input-file-ok");
          const message_error = input_wrap?.querySelector(".js-input-file-error");

          input_visible?.classList.remove("is-ok");
          message_hint?.classList.remove("is-hidden");
          
          if (message_ok) {
            message_ok.classList.add("is-hidden");
            message_ok.querySelector(".js-file-name").innerHTML = "";
          }
        });
      }
    }, false );
  }

  prefill_select() {
    const select = this.form.querySelector(".js-op-prefill");
    if (!select) return;
        
    this.data?.areas?.forEach(area => {
      const opt = document.createElement("option");
      opt.value = area.slug;
      opt.textContent = area.name;
      select.appendChild(opt);
    });

    // set default value
    if (!this.data?.position_areas.length > 0) return;

    const default_area = this.data.position_areas[0];    
    select.value = default_area.slug;
  }

  // merda
  init_inputs_file() {
    const inputs = this.form.querySelectorAll("input[type='file']");
    const config = { attributes: false, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          if (mutation.addedNodes?.length > 0) {
            const msg = mutation.addedNodes[0].cloneNode(true);            
            const input_wrap = mutation.target.closest(".input-wrap-file");
            const input_visible = input_wrap?.querySelector(".js-single-input-visible");
            const message_hint = input_wrap?.querySelector(".js-input-file-hint");
            const message_ok = input_wrap?.querySelector(".js-input-file-ok");
            const message_error = input_wrap?.querySelector(".js-input-file-error");
            
            if (!(message_hint && message_ok && message_error)) return;
            
            message_error.innerHTML = "";
            message_error.appendChild(msg);
            
            message_hint.classList.remove("is-hidden");
            !message_ok.classList.contains("is-hidden")
              && message_ok.classList.add("is-hidden");
            input_visible?.classList.remove("is-ok");
            !input_visible?.classList.contains("has-error")
              && input_visible.classList.add("has-error");
              
            message_error.classList.remove("is-hidden");
          }
        }
      }
    };
    const observer = new MutationObserver(callback);   
    // handle only upload OK 
    const handle_change = (e, input, input_visible, message_hint, message_ok, message_error) => {
      const file = e?.target?.files[0];
      
      if (!file || file?.size > parseInt(input.getAttribute("size")) * 100000) {
        return;
      }

      const name = file?.name;
      const label = message_ok.querySelector(".js-file-name");
      
      if (label) {
        label.textContent = name;
      }

      message_ok.classList.remove("is-hidden");

      !message_hint.classList.contains("is-hidden")
        && message_hint.classList.add("is-hidden");
      !message_error?.classList.contains("is-hidden")
        && message_error?.classList.add("is-hidden");
      input_visible.classList.remove("has-error");
      !input_visible.classList.contains("is-ok")
        && input_visible.classList.add("is-ok");
    };

    inputs?.forEach((input) => {
      const input_wrap = input.closest(".single-input-wrap");
      const input_visible = input_wrap?.querySelector(".js-single-input-visible");
      const message_hint = input_visible?.querySelector(".js-input-file-hint");
      const message_ok = input_visible?.querySelector(".js-input-file-ok");
      const message_error = input_wrap?.querySelector(".js-input-file-error");

      input.addEventListener(
        "change", 
        (e) => handle_change(e, input, input_visible, message_hint, message_ok, message_error)
      );
      observer.observe(input_visible.nextElementSibling, config);
    });    
  }
}